import Vue from 'vue';

import * as Integrations from '@sentry/integrations';
import * as Sentry from '@sentry/browser';

if (import.meta.env.VITE_ADD_SENTRY === 'true') {
  Sentry.init({
    release: `widget@${import.meta.env.VITE_VERSION}`,
    dsn: 'https://7d8f8a23b59c4f8b99394cd2766895d5@sentry.io/1884086',
    integrations: [new Integrations.Vue({ Vue, attachProps: false })],
    environment: import.meta.env.NODE_ENV,
  });
}
Vue.prototype.$Sentry = Sentry;
